"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { renderAllPages } from "@/workers/pdf-render";
type State = {
  file?: File;
  count?: number;
  thumbs: (Blob | undefined)[];
  error?: string;
};

/** Page count and a thumbnail for every page of one PDF, filled in as they render. */
export function usePdfPages(file, t0) {
  const $ = _c(8);
  const width = t0 === undefined ? 180 : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      thumbs: []
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [state, setState] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== file || $[2] !== width) {
    t2 = () => {
      if (!file) {
        return;
      }
      return renderAllPages(file, width, count => setState({
        file,
        count,
        thumbs: Array(count).fill(undefined)
      }), (i, thumb) => setState(old => {
        const thumbs = old.thumbs.slice();
        thumbs[i] = thumb;
        return {
          ...old,
          thumbs
        };
      }), error => setState({
        file,
        error,
        thumbs: []
      }));
    };
    t3 = [file, width];
    $[1] = file;
    $[2] = width;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== file || $[6] !== state) {
    t4 = state.file === file ? state : {
      thumbs: [] as (Blob | undefined)[]
    };
    $[5] = file;
    $[6] = state;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}